// @ts-strict-ignore
import React, { FC } from 'react'

import { AdaptedVariant } from '@/entities/Payments'

import { Radio } from '@/shared/ui/radio'

import cls from './ShopSelector.module.scss'

interface ShopSelectorProps {
	onChange?: (value: string) => void
	value: string
	items: AdaptedVariant[]
	baseUrl: string
}

const bankDescription: Record<string, string> = {
	direct_credit_rest: 'Одна анкета - 10 решений по заявке за 2 минуты',
	always_yes_21: 'Одна заявка сразу в несколько банков',
	always_yes_23: 'Одна заявка сразу в несколько банков',
	always_yes_30: 'Одна заявка сразу в несколько банков',
	always_yes_31: 'Одна заявка сразу в несколько банков',
	always_yes_limit_41: 'Одна заявка сразу в несколько банков',
	always_yes_limit_46: 'Одна заявка сразу в несколько банков',
	always_yes_limit_43: 'Одна заявка сразу в несколько банков',
	always_yes_limit_48: 'Одна заявка сразу в несколько банков',

	sberbank_pay_36: 'Быстрая заявка в личном кабинете СберБанка',
	sberbank_pay_37: 'Быстрая заявка в личном кабинете СберБанка',
	sberbank_pay_38: 'Быстрая заявка в личном кабинете СберБанка',
	sberbank_pay_39: 'Быстрая заявка в личном кабинете СберБанка',
	sberbank_online_53: 'Быстрая заявка в личном кабинете СберБанка',
	sberbank_online_54: 'Быстрая заявка в личном кабинете СберБанка',
	sberbank_online_55: 'Быстрая заявка в личном кабинете СберБанка',
	sberbank_online_56: 'Быстрая заявка в личном кабинете СберБанка',

	always_yes_limit_42: 'Оплатите покупку одобренным Лимитом',
	always_yes_limit_44: 'Оплатите покупку одобренным Лимитом',
	always_yes_limit_47: 'Оплатите покупку одобренным Лимитом',
	always_yes_limit_49: 'Оплатите покупку одобренным Лимитом',

	t_bank_51: 'Одобрение заявки за 1-2 минуты',
	t_bank_52: 'Одобрение заявки за 1-2 минуты'
}
export const ShopSelector: FC<ShopSelectorProps> = ({ onChange, value, items, baseUrl }) => (
	<Radio.Group
		className={cls.shopsSelector}
		onChange={evt => onChange?.(evt.target.value)}
		buttonStyle="solid"
		value={value}>
		{items.map(({ id, name, logotip, system }) => {
			const description = bankDescription[system] ?? bankDescription[`${system}_${id}`]
			return (
				<Radio.Button className={cls.shopsSelector__item} key={id} value={id}>
					<div className={cls.shopsSelector__itemInfo}>
						<div className={cls.shopsSelector__imageWrap}>
							{/* eslint-disable-next-line @next/next/no-img-element */}
							<img alt={name} src={baseUrl + logotip} loading="lazy" width={32} height={32} />
						</div>
						<p className={cls.shopsSelector__itemName}>{name}</p>
						{description && <p className={cls.shopsSelector__description}>{description}</p>}
					</div>
				</Radio.Button>
			)
		})}
	</Radio.Group>
)
